import { useEffect, useState } from "react";
import { set, useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { Badge, Button, Col, DropdownMenu, DropdownToggle, Form, Modal, ModalBody, ModalHeader, Row, UncontrolledDropdown } from "reactstrap";
import Head from "../../../layout/head/Head";
import Content from "../../../layout/content/Content";
import {   Block,
  BlockBetween,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  Icon,
  PreviewAltCard,
  TooltipComponent,
  UserAvatar, } from "../../../components/Component";
import { labAPI } from "../../../api/doctor";
import useLogout from "../../../hooks/useLogout";
import MyDataTable from "../../../MyComp/UI/DataTable/MyDataTable";
import { BASE_URL_IMG } from "../../../assets/constants";
import { uploadTestCatalog } from "../../../api/master/indes";











const LaboratoryList = () => {
  const {
    register,
    handleSubmit,
    setValue,
    watch,
    trigger,
    reset,
    formState: { errors },
  } = useForm({
    defaultValues: {
      server_search: "",
      page: 1,
      limit: 25,
    },
  });
   const {
    clearErrors: clearErrorsTest,
    register: registerTest,
    handleSubmit: handleSubmitTest,
    control: controlTest,
    setValue: setValueTest,
    watch: watchTest,
    trigger: triggerTest,
    formState: { errors: errorsTest },
    reset: resetTest,
   setError: setErrorTest
  } = useForm({
    defaultValues: {
      isLoading: false,
      addSub: false,
      data: [],
    },
    mode: "onChange",
  });
  const { logout } = useLogout();
  const navigate = useNavigate();
  // Separate table state from form
  const [tableData, setTableData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [mode, setMode] = useState("Add");
  const [imageOpen, setImageOpen] = useState(false);
  //pagination
  const [totalRows, setTotalRows] = useState(0);
  const [perPage, setPerPage] = useState(25);
  const [currentPage, setCurrentPage] = useState(1);

  // pagination
  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handlePerRowsChange = (newPerPage, page) => {
    setPerPage(newPerPage);
    setCurrentPage(page);
  };
  const [search, setSearch] = useState("");
  const [resetPaginationToggle, setResetPaginationToggle] = useState(false);

  const columns = [
    {
      name: "Name",
      selector: (row) => row?.name || "-",
    },
    {
      name: "Type",
      width:"220px",
      selector: (row) => <>
      {(row?.labCategoryName || "-")
  .split(",")
  .map((category, index) => (
    <Badge key={index} color="outline-secondary me-1 my-1">{category.trim()}</Badge>
))}

        </>, 
    
    },
    {
      name: "Address",
      selector: (row) => row?.address || "-", 
      wrap: true, 
    },
    {
      name: "Mobile Number",
      selector: (row) => row?.mobile || row?.mobile || "-",
       sortable: true,
      wrap: true,
      width: "140px",
    },
    {
      name: "District",
      selector: (row) => row?.district || row?.district || "-",
       sortable: true,
      wrap: true,
      width: "140px",
    },
    {
      name: "KYC",
      selector: (row) => row?.kyc_status,
      cell: (row) => (
        <div
          style={{ cursor: "pointer" }}
          //  onClick={() => handleToggleStatus(row)}
        >
          <Badge
            className="text-capitalize"
            color={`${
              row.kyc_status == "pending"
                ? "outline-warning"
                : row?.kyc_status == "Approved"
                  ? "outline-primary"
                  : row?.kyc_status == "In Review"
                    ? "outline-info"
                    : "outline-danger"
            }`}
          >
            {row?.isSelected && <Icon color={"success"} name={row?.isSelected ? "star" : ""} />}
            {row.kyc_status}
          </Badge>
        </div>
      ),
      sortable: true,
      wrap: true,
      width: "100px",
    },
    {
      name: "Status",
      selector: (row) => row?.status,
      cell: (row) => (
        <div style={{ cursor: "pointer" }} 
        // onClick={() => handleToggleStatus(row)}
        >
          <Badge color={row.status ? "success" : "danger"}>{row.status ? "Active" : "InActive"}</Badge>
        </div>
      ),
      sortable: true,
      width: "90px",
    },
    {
      name: "Action",
      // width: "100px",
      cell: (row) => (
        <>
          {row?.kyc_status == "Approved" ? null : (
            <>
              <Button
                id={`app-${row?.id}`}
                className="mx-1"
                outline
                color="success"
                size="xs"
                onClick={() => handleShowDetails(row)}
              >
                <Icon name="eye" />
              </Button>
              <TooltipComponent
                iconClass="card-hint"
                direction="top"
                id={`app-${row?.id}`}
                text="View and Approval Laboratory"
              />
            </>
          )}
             <Button
                id={`app-${row?.id}`}
                className="mx-1"
                outline
                color="warning"
                size="xs"
                onClick={() => handleEdit(row)}
              >
                <Icon name="edit" />
              </Button>
        </>
      ),
    },
  ];

  useEffect(() => {
    fetchLabs();
  }, [currentPage, perPage, search]);

  const fetchLabs = async () => {
    setLoading(true);

    const body = {
      search,
      page: currentPage,
      limit: perPage,
    };

    try {
      const res = await labAPI(body);

      if (res?.data?.status === true) {
        const apiData = res?.data?.data || {};

        const rows = Array.isArray(apiData)
          ? apiData
          : Array.isArray(apiData)
            ? apiData
            : Array.isArray(apiData)
              ? apiData
              : [];

        const total = apiData.totalRecords || apiData.total || 0;
        console.log(rows);

        setTableData(rows);
        setTotalRows(total);
      } else {
        setTableData([]);
        setTotalRows(0);
      }
    } catch (error) {
      console.error("Lab API Error:", error);
      toast.error("Failed to load lab list");
      setTableData([]);
      setTotalRows(0);
    } finally {
      setLoading(false);
    }
  };
  const handleShowDetails = (row) => {
    console.log("rowEdit", row);
    navigate(`/laboratory-details?labId=${row?.id}`, { state: { labId: row?.id, mode: "Approval" } });
  };
    const handleEdit = (row) => {
    console.log("rowEdit", row);
    navigate(`/laboratory-and-diagnostics/lab-and-diagnostic-profile`, { state: { labId: row?.id, mode: "Edit" } });
  };
const handleUploadClick = () => {
      setDownloadModalOpen(true);
    };
      const labId = localStorage.getItem("userId");
    const [downloadModalOpen, setDownloadModalOpen] = useState(false);
    // New: Handle Upload click to show download modal
    const uploadTestCatalogAPI = async () => {
      try {
        setUploading(true);
        const file = watchTest("file");
        if (!file) {
          toast.errorsTest("Please select an Excel file");
          return;
        }
        const formData = new FormData();
        formData.append("file", file);
        formData.append("labId", labId);
  
        const res = await uploadTestCatalog(formData);
  
        if (res?.data?.status === "expired") {
          toast.error(res.data.message);
          toast.clearWaitingQueue();
          logout();
        } else if (res?.data?.status === true) {
          toast.success(res.data.message || "Excel uploaded successfully");
          handleCancel();
          setDownloadModalOpen(false);
          setValueTest("data", res.data.data || []);
        } else {
          toast.error(res?.data?.message || "Upload failed");
        }
      } catch (err) {
        toast.error(err?.response?.data?.message || "Upload failed");
      } finally {
        setUploading(false);
      }
    };
  
    const handleChange = (e) => {
      const selectedFile = e.target.files[0];
  
      if (!selectedFile) {
        setValueTest("file", null);
        setErrorTest("file", { type: "manual", message: "File is required" });
        return;
      }
  
      validateExcel(selectedFile, (isValid) => {
        if (isValid) {
          clearErrorsTest("file");
          setValueTest("file", selectedFile);
        } else {
          setValueTest("file", null);
          setErrorTest("file", { type: "manual", message: "Invalid file type. Please upload a valid Excel file." });
          toast.error("Invalid file type. Please upload a valid Excel file.");
          e.target.value = null;
        }
      });
    };
    useEffect(() => {
      if (!downloadModalOpen) {
        setValueTest("file", null);
        clearErrorsTest("file");
  
        // reset actual file input DOM value
        const input = document.getElementById("fileInput");
        if (input) {
          input.value = "";
        }
      }
    }, [downloadModalOpen]);
    const handleCancel = () => {
      setValueTest("file", null);
      clearErrorsTest("file");
  
      const input = document.getElementById("fileInput");
      if (input) {
        input.value = "";
      }
    };
  
    // const handleCancel = () => {
    //   setValue("file", null);
    //   clearErrors("file");
    // };
    const validateExcel = (file, callback) => {
      const reader = new FileReader();
  
      const fileName = file.name.toLowerCase();
      const isXlsExtension = fileName.endsWith(".xls");
      const isXlsxExtension = fileName.endsWith(".xlsx");
  
      if (!isXlsExtension && !isXlsxExtension) {
        callback(false);
        return;
      }
  
      reader.onloadend = function (event) {
        const arr = new Uint8Array(event.target.result).subarray(0, 4);
        let header = "";
        for (let i = 0; i < arr.length; i++) {
          header += arr[i].toString(16).padStart(2, "0");
        }
        header = header.toUpperCase();
  
        const isXls = header === "D0CF11E0"; // XLS
        const isXlsx = header === "504B0304"; // XLSX
        const isExcel = (isXls && isXlsExtension) || (isXlsx && isXlsxExtension);
  
        callback(isExcel);
      };
  
      reader.onerror = function () {
        callback(false);
      };
  
      reader.readAsArrayBuffer(file.slice(0, 4));
    };
    const [uploading, setUploading] = useState(false);

  
  
    const handleSampleFileOpen = () => {
      const upload = "upload-test-catalog";
      const fileName = `${BASE_URL_IMG}${upload}`;
      // Replace 'sample_file.txt' with the name of your sample file
      // const fileName = watch("file_name");
      var filePath;
      // Path to your sample file
      // if (selectedType?.value == "facility") {
      filePath = ` ${watch("file_name")}`; // Update the path
      // } else {
      //   filePath = `${base}${sampelFileV2}`; // Update the path
      // }
      const link = document.createElement("a");
      link.href = filePath;
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    };
  return (
    <>
      <Head title="Lab" />
      <Content>
        <BlockHead size="sm">
          <BlockBetween>
            <BlockHeadContent>
              <BlockTitle page tag="h3">
                Laboratory
              </BlockTitle>
            </BlockHeadContent>
            <BlockHeadContent>  <> <Button color="primary" outline style={{ marginRight: "15px" }} onClick={handleUploadClick}>
                  <Icon name="upload" />
                </Button>
              <Button
                color="primary"
                outline
                className="me-n1"
                onClick={() => {
                  navigate("/laboratory-and-diagnostics/lab-and-diagnostic-profile", { state: { mode: "Add" } });
                }}
              >
                <Icon name={isOpen ? "minus" : "plus"} />
              </Button></>
            </BlockHeadContent>
          </BlockBetween>
        </BlockHead>

        <Block>
          {/* <Row className="mb-3">
            <Col md="4">
              <input
                type="text"
                className="form-control"
                placeholder="Search lab..."
                value={search}
                onChange={(e) => {
                  setSearch(e.target.value);
                  setCurrentPage(1);
                  setResetPaginationToggle((prev) => !prev);
                }}
              />
            </Col>
          </Row> */}
<Modal isOpen={downloadModalOpen} toggle={() => setDownloadModalOpen(false)} centered>
        <ModalHeader toggle={() => setDownloadModalOpen(false)}>Upload Test Catalog (Excel)</ModalHeader>

        <ModalBody>
          <div className="d-block justify-content-between">
            <div
              style={{
                // maxWidth:'250px',
                border: "2px dashed #cfd4da",
                borderRadius: "10px",
                padding: "5px",
                textAlign: "center",
                background: "#f8f9fa",
              }}
            >
              {watchTest("file") ? (
                <div
                  style={{
                    border: "1px solid #dee2e6",
                    borderRadius: "10px",
                    padding: "20px",
                    background: "#ffffff",
                  }}
                >
                  <Icon name="file-excel" style={{ fontSize: "28px", color: "green" }} />
                  <p
                    style={{
                      marginTop: "10px",
                      wordBreak: "break-word",
                      fontWeight: "600",
                    }}
                  >
                    {watchTest("file")?.name}
                  </p>

                  <div className="d-flex justify-content-center gap-2 mt-3">
                    <Button color="danger" size="sm" className="p-2" outline onClick={handleCancel}>
                      Remove
                    </Button>
                    <Button
                      className="p-2"
                      color="primary"
                      size="sm"
                      disabled={uploading}
                      onClick={uploadTestCatalogAPI}
                    >
                      {/* {uploading ? "Uploading..." : "Upload"} */}
                      {"Upload"}
                    </Button>
                  </div>
                </div>
              ) : (
                /* FILE INPUT */
                <>
                  <label
                    htmlFor="fileInput"
                    style={{
                      cursor: "pointer",
                      display: "block",
                    }}
                  >
                    <Icon name="upload" style={{ fontSize: "30px", color: "#0d6efd" }} />
                    <p style={{ marginTop: "5px", fontWeight: "500" }}>Click to upload test catalog</p>
                    {/* <small style={{ color: "#6c757d" }}>
              Supported formats: .xls, .xlsx
            </small> */}
                  </label>

                  <input
                    type="file"
                    id="fileInput"
                    accept=".xls,.xlsx"
                    style={{ display: "none" }}
                    {...registerTest("file", { requiredTest: "File is required" })}
                    onChange={handleChange}
                  />

                  {errorsTest.file && (
                    <div style={{ color: "red", fontSize: "11px", marginTop: "5px" }}>{errorsTest.file.message}</div>
                  )}
                </>
              )}
            </div>

            {/* SAMPLE DOWNLOAD */}
            <div
              style={{
                border: "2px,solid,lightgray",
                borderRadius: "10px",
                paddingLeft: "50px",
                marginBottom: "10px",
                paddingTop: "15px",
                paddingRight: "25px",
                paddingBottom: "15px",
                marginTop: "10px",
                textAlign: "center",
                display: "flex",
                flexDirection: "column",
                gap: "6px",
                alignItems: "center",
              }}
            >
              <small style={{ color: "crimson" }}>Download sample Excel</small>

              <Button size="sm" color="primary" outline onClick={handleSampleFileOpen}>
                <Icon name="download" /> Sample
              </Button>
            </div>
          </div>
        </ModalBody>
      </Modal>
          <MyDataTable data={tableData} columns={columns} title="Laboratory List" isLoading={loading} />
          {/* <ServerSideDataTable
            columns={columns}
            data={tableData}
            title="Lab List"
            isLoading={loading}
            totalRows={totalRows}
            perPage={perPage}
            currentPage={currentPage}
            handlePageChange={handlePageChange}
            handlePerRowsChange={handlePerRowsChange}
            resetPaginationToggle={resetPaginationToggle}
          /> */}
        </Block>
      </Content>
    </>
  );
};

export default LaboratoryList;
